/* eslint-disable parog-web/no-glint-expect-error-directive */
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { formatMessage } from 'ember-intl';
import WrButton from 'ember-wiser/components/button';
import EditComment from 'parog-web/components/alerts-and-notifications/comment/add-comment';
import ArchiveJournalEventButton from 'parog-web/components/archive-journal-event-button';
import type CommentWrittenJournalEvent from 'parog-web/models/comment-written-journal-event';
import TimeZoneWithWarning from 'ui-kit/components/timezone-with-warning';
import fuiPopup from 'wise-fui-modules/modifiers/fui-popup';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    comment: CommentWrittenJournalEvent;
    shouldHideSuggestion?: boolean;
  };
}

export default class Comment extends Component<Signature> {
  @tracked shouldShowComment = false;

  closeComment = (): void => {
    this.shouldShowComment = false;
  };

  toggleComment = (): void => {
    this.shouldShowComment = !this.shouldShowComment;
  };

  <template>
    <div
      class='bg-grey-light text-grey flex items-start gap-2 p-2'
      data-test-comment={{@comment.id}}
      ...attributes
    >
      {{! COMMENT TEXT AND CREATOR }}
      <div class='flex grow flex-col gap-2'>
        <span>
          <TimeZoneWithWarning
            @date={{@comment.occurredAt}}
            @originalOffsetInSeconds={{@comment.occurredAtOffsetInSeconds}}
          >
            {{formatMessage
              'Le {occurredAt, date} à {occurredAt, time, hhmm}'
              occurredAt=@comment.occurredAt
            }}
          </TimeZoneWithWarning>

          {{@comment.creator.fullName}}
        </span>
        <span class='whitespace-pre-line'>{{@comment.comment}}</span>
      </div>

      {{! EDIT BUTTON }}
      <WrButton
        @icon='Pen'
        @variant='outlined-mini'
        data-tooltip='Modifier'
        {{on 'click' this.toggleComment}}
        data-test-edit-comment={{@comment.id}}
      />

      {{! ARCHIVE BUTTON }}
      <ArchiveJournalEventButton
        @shouldUseWiser={{true}}
        @journalEvent={{@comment}}
        {{fuiPopup position='top right' content='Supprimer'}}
        data-test='archive-comment-{{@comment.id}}'
        data-test-archive-comment={{@comment.id}}
      />
    </div>

    {{#if this.shouldShowComment}}
      <EditComment
        @commentWrittenJe={{@comment}}
        {{! @glint-expect-error }}
        @item={{@comment.originJournalEvent}}
        @onClose={{this.closeComment}}
        @shouldHideSuggestion={{@shouldHideSuggestion}}
      />
    {{/if}}
  </template>
}
